import { api } from './api'

export interface BillingStatus {
  trial_ends_at: string
  billing_status: string
  payment_method_on_file: boolean
  stripe_configured: boolean
  trial_active: boolean
  requires_payment_setup: boolean
  days_left_in_trial: number
}

export const billingService = {
  async getStatus(): Promise<BillingStatus> {
    const response = await api.get('/billing/status')
    return response.data
  },

  async createCheckoutSession(): Promise<{ url: string }> {
    const origin = window.location.origin
    const response = await api.post('/billing/checkout-session', {
      success_url: `${origin}/billing/success`,
      cancel_url: `${origin}/billing`,
    })
    return response.data
  },
}
